var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[(_vm.tagType == 'div')?_c('div',{staticClass:"embed-responsive embed-responsive-16by9",domProps:{"innerHTML":_vm._s(_vm.innerHTML)}}):(_vm.tagType == 'a')?_c('a',{attrs:{"href":_vm.href,"target":"_blank"},domProps:{"textContent":_vm._s(_vm.innerText)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }